<div class="google-map-container dashboard-map">
  @if (googleMapsLoaded && mapSettingsInitialized) {
    <google-map (boundsChanged)="startPollingForVisiblePins()" #googleMap="googleMap" [options]="mapSettings.options"
      height="100%"
      id="map"
      width="100%">
      <div class="map-hint">
        <p class="mb-0">
          <i class="fa-solid fa-circle-info mr-2"></i>
          <span translate>Only machines with configured addresses are shown.</span></p>
        </div>
        <map-marker-clusterer (clusterClick)="onClusterClick($event, clusterInfoWindow)" [algorithm]="clusterAlgorithm" [renderer]="clusterRenderer">
          <map-info-window #clusterInfoWindow="mapInfoWindow" class="map-window-cluster">
            <div class="px-2">
              @for (marker of currentCluster; track marker; let i = $index; let last = $last) {
                <div
                  class="map-window-row form-row align-items-center">
                  <div class="col col-title">
                    <em [ngClass]="defineStatusIcon(marker.get('trafficLight'))"
                    class="fa-solid fa-2x mr-2"></em>
                    <div [innerHTML]="marker.getTitle()" [title]="marker.getTitle()" class="h6 mb-0 truncate"></div>
                  </div>
                  <div class="col-auto">
                    <div class="btn-container">
                      <button (click)="redirectToGoogleMaps(marker.getPosition())"
                        [title]="'Get directions' | translate"
                        class="btn btn-sm btn-outline-primary"
                        type="button">
                        <em class="fa-solid fa-route"></em>
                      </button>
                      <button (click)="redirectToFirstMenuEntry(marker)"
                        [title]="'Go to machine' | translate"
                        class="btn btn-sm btn-outline-primary ml-2"
                        type="button">
                        <i class="fa-solid fa-gears"></i>
                      </button>
                    </div>
                  </div>
                </div>
              }
            </div>
          </map-info-window>
          @for (marker of mapSettings.markers; track marker) {
            <map-marker #mapMarker="mapMarker" (mapClick)="openInfoWindow(mapMarker, infoWindow)"
              [options]="marker['options']" [position]="marker['position']">
            </map-marker>
          }
          <map-info-window #infoWindow="mapInfoWindow" class="map-window-pin">
            <div class="p-1" style="min-width: 160px;">
              <h6 [innerText]="currentMarker?.getTitle()" class="h6 mb-3 truncate"></h6>
              <button (click)="redirectToGoogleMaps(currentMarker?.getPosition())"
                class="btn btn-sm btn-outline-primary btn-block"
                type="button">
                <em class="fa-solid fa-route"></em>
                @if (currentPositionAvailable) {
                  <span translate>Directions</span>
                }
                @if (!currentPositionAvailable) {
                  <span translate>Show on maps</span>
                }
              </button>
              @if (groupId) {
                <button (click)="redirectToFirstMenuEntry(currentMarker)"
                  class="btn btn-sm btn-primary btn-block"
                  type="button">
                  <i class="fa-solid fa-gears"></i>
                  <span translate>More Details</span>
                </button>
              }
            </div>
          </map-info-window>
        </map-marker-clusterer>
      </google-map>
    }

    @if (!map) {
      <div
        class="page-content page-content-full card content-loading d-flex align-items-center justify-content-center">
        <div class="text-center">
          <div class="mb-2 display-4 text-primary">
            <span class="fa-solid fa-spinner fa-spin"></span>
          </div>
          <p>
            <strong translate>Loading map</strong><br>
            <span translate>Please wait ...</span>
          </p>
        </div>
      </div>
    }
  </div>
